





import {Component} from 'vue-property-decorator';
import Vue from 'vue';
import {Action, State} from 'vuex-class';
import {AddressInitState, Amphures, Districts, Provinces} from '@/store/address/address.types';
import {RegisterEnum} from '@/store/auth/auth.enum';
import {Member} from '@/store/member/member.types';

@Component({
  components: {}
})
export default class AddressPermanentComponent extends Vue {

  @State('address') addressInitState!: AddressInitState;
  @Action('_getProvinces', {namespace: 'address'}) getProvinces!: () => Promise<void>;
  @Action('_getAmphures', {namespace: 'address'}) getAmphures!: (payload: string) => Promise<void>;
  @Action('_getDistricts', {namespace: 'address'}) getDistricts!: (payload: string) => Promise<void>;

  public provinces = [{id: 0}] as Provinces[];
  public MemberData = {} as Member;


  async mounted() {
    this.MemberData = JSON.parse(localStorage.getItem(RegisterEnum.Register) as string) as Member;
    await this.getProvinces();
    this.provinces = this.addressInitState.provinces;
  }

}
